import SaleConfirmationContent from "../../../../src/pages/pricing/contact/sales/sale-confirmation-content.md";
import { GoogleTagManager } from "../../../../src/components/retargetting";
import * as React from 'react';
export default {
  SaleConfirmationContent,
  GoogleTagManager,
  React
};